import { DataCache, Predicate, injectDataCache, predicate } from '@aesop-fables/scrinium';
import { Observable, combineLatest, distinctUntilChanged, map, shareReplay } from 'rxjs';
import { pricebookStorageKey, PricebookCompartments } from '../data/pricebook';
import { SelectionData } from '../api/apis/PricebookApi';
import { PricebookBundle } from '../models/PricebookData';
import { Predicates } from './Types';

@predicate(Predicates.IsAuthenticated)
export class PricebooksSelected implements Predicate {
  constructor(
    @injectDataCache(pricebookStorageKey)
    private readonly pricebookDataCache: DataCache<PricebookCompartments>,
  ) {}

  createObservable(): Observable<boolean> {
    return combineLatest([
      this.pricebookDataCache.observe$<SelectionData[]>('pricebookSelectionIds'),
      this.pricebookDataCache.observe$<PricebookBundle[]>('pricebookOptions'),
    ]).pipe(
      map(([pricebookSelectionIds = [], pricebookOptions = []]) => {
        if (pricebookSelectionIds.length === 0 || pricebookOptions.length === 0) {
          return false;
        }

        const optionIds = new Set(pricebookOptions.map(({ pricebook }) => pricebook.id));
        return pricebookSelectionIds.some(({ pricebookId }) => optionIds.has(pricebookId));
      }),
      distinctUntilChanged(),
      shareReplay(1),
    );
  }
}
